<div class="gift-detail-component">
  <div class="ws-popup-header">
    <div class="gift-ref">
      <div class="gift-ref-title">Id: </div>
      <div class="gift-ref-id">{{ gift?.giftId }}</div>
    </div>
    <div class="gift elavation2">
      gift <i class="icon-gift-box-open"></i>
    </div>
    <div *ngIf="gift.redemptionDate != null && !returnToReservation" class="reservation-linked">
      <ws-button (click)="openReservation()" class="link-reservation" [callToActionType]="'tertiary'">
        {{ "Open booking details" | translate }}
      </ws-button>
    </div>

    <div class="actions">
      <mat-icon
        *ngIf="invoiceKeys.length > 0"
        [wsTooltip]="'Client has requested an invoice' | translate"
        class="invoice-requested-icon"
      >
        error
      </mat-icon>
      <button
        (click)="openReservation()"
        *ngIf="gift.redemptionDate != null && returnToReservation"
        mat-icon-button
      >
        <i class="icon-back"></i>
      </button>
      <button [matMenuTriggerFor]="moreOptions" mat-icon-button>
        <mat-icon>more_vert</mat-icon>
      </button>
      <button mat-icon-button (click)="closeClicked()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-menu #moreOptions="matMenu" xPosition="before">
    <button (click)="getGiftVoucher()" mat-menu-item>
      <mat-icon>print</mat-icon>
      {{ "Print" | translate }}
    </button>

    <button (click)="sendGiftEmail()" mat-menu-item>
      <mat-icon>mail</mat-icon>
      {{ "Send gift email" | translate }}
    </button>

    <button
      *ngIf="invoiceKeys.length > 0"
      (click)="openBillingData()"
      mat-menu-item
    >
      <mat-icon>receipt_long</mat-icon>
      {{ "View billing information" | translate }}
    </button>

  <web-external-sync-button
    *ngFor="let button of syncButtons"
    [label]="button.label | translate"
      [matIconName]="button.icon"
    [successMessage]="button.successMessage | translate"
    [errorMessage]="button.errorMessage | translate
      "
    [actionObservable]="button.actionObservable"
    [statusObservable]="button.statusObservable"
  ></web-external-sync-button>
</mat-menu>

  <div class="ws-popup-content">
    <div class="ws-popup-body">
      <div class="content-wrapper" [formGroup]="form">
        <div class="field-wrapper first-row">
          <label for="title">
            {{ "Experience" | translate }}
          </label>
          <input
            [value]="experienceTitleValue"
            id="title"
            class="big-select"
            matInput
            readonly
            type="text"
            style="width: 100% !important"
          />
        </div>

        <div class="content-row section-top">
          <div class="content-left">
            <div class="field-wrapper">
              <label for="buyer">
                {{ "Buyer Name" | translate }}
              </label>
              <input
                [value]="buyerNameValue"
                id="buyer"
                class="big-select"
                matInput
                readonly
                type="text"
                style="width: 100% !important"
              />
            </div>

            <div class="field-wrapper">
              <label for="email-buyer">
                {{ "Buyer Email" | translate }}
              </label>
              <input
                [value]="buyerEmailValue"
                id="email-buyer"
                class="big-select"
                matInput
                readonly
                type="text"
              />
            </div>
          </div>
          <div class="content-right">
            <div class="field-wrapper">
              <label for="beneficiary">
                {{ "Recipient Name" | translate }}
              </label>
              <input
                type="text"
                matInput
                id="beneficiary-name"
                formControlName="beneficiaryName"
              />
            </div>

            <div class="field-wrapper">
              <label for="email-beneficiary">
                {{ "Recipient Email" | translate }}
              </label>
              <input type="text" matInput id="beneficiary-email" formControlName="beneficiaryEmail" />
            </div>
          </div>
        </div>

        <div class="content-row second-section">
          <div class="content-left">
            <div class="field-wrapper">
              <label for="purchased-date">
                {{ "Date of purchase" | translate }}
              </label>
              <input
                [value]="purchasedDateValue"
                id="purchased-date"
                matInput
                readonly
                type="text"
              />
            </div>
            <div class="field-wrapper">
              <label for="origin">
                {{ "Origin" | translate }}
              </label>
              <input
                [value]="originValue"
                id="origin"
                class="big-select"
                matInput
                readonly
                type="text"
              />
            </div>
          </div>
          <div
            class="content-center content-center-scroll scrollbar-overflow-y"
          >
            <div class="field-wrapper">
              <label for="sent-date">
                {{ "Sending date" | translate }}
                <web-info-icon-hoverable
                  description="{{
                    'By selecting today as the new sending date, the gift email will be sent right after saving.'
                      | translate
                  }}"
                ></web-info-icon-hoverable>
              </label>
              <input
                formControlName="sendingDate"
                id="sent-date"
                matInput
                type="text"
                [matDatepicker]="sendingDatePicker"
                [matDatepickerFilter]="validateGiftSendingDate"
              />
              <mat-datepicker-toggle
                class="pen"
                matSuffix
                [for]="sendingDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #sendingDatePicker></mat-datepicker>
            </div>
            <div class="field-wrapper">
              <label for="price01">
                {{ price01label() | truncate : [12, "..."] }}
              </label>
              <input
                [value]="price01Value"
                id="price01"
                class="big-select"
                matInput
                readonly
                type="text"
              />
            </div>

            <div class="field-wrapper gift-children" *ngIf="gift.children">
              <label for="price02">
                {{ price02label() | truncate : [12, "..."] }}
              </label>
              <input
                [value]="price02Value"
                id="price02"
                class="big-select"
                matInput
                readonly
                type="text"
              />
            </div>

            <div
              class="field-wrapper gift-price-labels"
              *ngFor="let priceLabel of formPriceLabelsArray; let last = last"
              [formGroup]="priceLabel"
            >
              <label for="priceLabel">
                {{
                  priceLabel.get("title_translations")?.value["it"]
                    | truncate : [12, "..."]
                }}
              </label>
              <input
                [value]="priceLabel.get('quantity')?.value"
                id="priceLabel"
                class="big-select"
                matInput
                readonly
                type="text"
              />
            </div>
          </div>
          <div class="content-right">
            <div class="field-wrapper">
              <label for="expiration-date">
                {{ "Expiration date" | translate }}
                <web-info-icon-hoverable
                  *ngIf="!isRedeemed"
                  description="{{
                    'The expiration date can be changed to any date equal to or after the purchase date.'
                      | translate
                  }}"
                ></web-info-icon-hoverable>
              </label>
              <input
                *ngIf="!isRedeemed"
                formControlName="expirationDate"
                id="expiration-date"
                matInput
                type="text"
                [matDatepicker]="expirationDatePicker"
                [matDatepickerFilter]="validateGiftExpirationDate"
              />
              <mat-datepicker-toggle
                *ngIf="!isRedeemed"
                class="pen"
                matSuffix
                [for]="expirationDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker
                *ngIf="!isRedeemed"
                #expirationDatePicker
              ></mat-datepicker>
              <input
                *ngIf="isRedeemed"
                [value]="expirationDateFormattedValue"
                id="expiration-date"
                matInput
                readonly
                type="text"
              />
            </div>

            <div class="field-wrapper">
              <label for="status">
                {{ "Status" | translate }}
              </label>
              <ws-chip
                [label]="getLabelForStatus() | titlecase | translate"
                [type]="statusBgColorFn()"
              >
              </ws-chip>
            </div>
          </div>
        </div>

        <div class="content-row third-section">
          <div class="content-left">
            <div class="field-wrapper">
              <label for="redemption-date">
                {{ "Reservation date" | translate }}</label
              >
              <input
                [value]="redemptionDateValue"
                id="redemption-date"
                class="big-select"
                matInput
                readonly
                type="text"
              />
            </div>

            <div class="field-wrapper">
              <label for="discountCode">
                {{ "Discount code" | translate }}
              </label>
              <input
                [value]="discountCodeValue"
                id="discountCode"
                class="big-select"
                matInput
                readonly
                type="text"
              />
            </div>
          </div>
          <div class="content-center">
            <div class="field-wrapper">
              <label for="reservation-id">
                {{ "Reservation id" | translate }}</label
              >
              <input
                [value]="reservationIdValue"
                id="reservation-id"
                matInput
                readonly
                type="text"
              />
            </div>
            <div class="field-wrapper">
              <label for="discount">
                {{ "Discount" | translate }}
              </label>
              <input
                [value]="
                  discountValue
                    | currency : gift.amountCurrency : 'symbol' : '1.0-2'
                "
                id="discount"
                class="big-select"
                matInput
                readonly
                type="text"
              />
            </div>
          </div>
          <div class="content-right">
            <div class="field-wrapper">
              <label for="method">
                {{ "Method" | translate }}
              </label>
              <input
                [value]="methodValue.toString() | translate"
                id="method"
                class="big-select"
                matInput
                readonly
                type="text"
              />
            </div>
            <div class="field-wrapper">
              <label for="total" class="emphasis">
                {{ "Total" | translate }}
              </label>
              <input
                [value]="
                  totalValue
                    | currency : gift.amountCurrency : 'symbol' : '1.0-2'
                "
                id="total"
                class="big-select"
                matInput
                readonly
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="ws-popup-footer actions-footer"
        [ngStyle]="{
          'border-top': !isRedeemed
            ? '1px solid var(--color-base-7, #d2d2d2)'
            : 'none'
        }"
      >
        <div *ngIf="!isRedeemed">
          <ws-button
            class="cancel"
            *ngIf="isEdited()"
            [callToActionType]="'danger'"
            [disabled]="isSaving"
            (click)="cancelEditing()"
          >
            {{ "Cancel" | translate }}
          </ws-button>

          <ws-button
            class="redeem"
            *ngIf="!form.get('redemptionDate')?.value && !isExpired()"
            [callToActionType]="'tertiary'"
            [disabled]="isLoadingRedeem || isSaving"
            (click)="redeemGift()"
          >
            {{ "Redeem" | translate }}
          </ws-button>

          <ws-button class="save" [callToActionType]="'primary'" [disabled]="!isEdited() || isSaving"
            (click)="updateGift()"
            >{{ "Save" | translate }}
          </ws-button>
        </div>
      </div>
    </div>
  </div>


</div>
